import { gql } from '@apollo/client';

export const UPDATE_USER_INTERVIEWS_TESTER_PAY_STATUS = gql`
  mutation UpdateUserInterviewsTesterPayStatus($testerId: ID!, $status: UserInterviewsPayStatusEnum!) {
    updateUserInterviewsTesterPayStatus(testerId: $testerId, status: $status) {
      tester {
        id
        userInterviewsPayStatus
      }
    }
  }
`;
